<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputName" });
import { InputText } from "../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
</script>

<InputText
    bind:value
    on:blur
    placeholder = 'resource.organization.properties.name.placeholder'
    label = 'resource.organization.properties.name.label'
    name = 'organization.name'
    autocomplete = 'organization'
    { isDisabled }
    { isReadonly }
    { isRequired }
    minLength = { 2 }
/>